import { Route, Routes } from 'react-router';
// import SawCutQueue from '../pages/Material/SawCutQueue';
import SawCutQueue from '../pages/Operations/SawCutQueue';
import SawCutQueueDetail from '../pages/Operations/SawCutQueue/SawCutQueueDetail';
import HomeOperations from '../pages/Operations';
import Kitting from '../pages/Operations/Kitting';
import QCMachine from '../pages/Operations/QualityControl/QCMachine';
import Keyence from '../pages/Operations/QualityControl/Keyence';
import InspectionResultsEntryPage from '../pages/Operations/QualityControl/Manual/';
import ProductQualityPage from '../pages/Operations/QualityControl/Product';
import Delivery from '../pages/Operations/Delivery';
import ReceivingPage from '../pages/Operations/Receiving';
import TabletMaterialLengthsPage from '../pages/Operations/MaterialLengths/TabletMaterialLengthsPage';
import KitStagingTabletPage from '../pages/KitStaging/KitStagingTabletPage';
import JawConfiguration from '../pages/Operations/JawConfiguration';
import Reservations from '../pages/Operations/Reservations';

const TabletRoutes = () => {
	return (
		<Routes>
			<Route path="operations" element={<HomeOperations />} />
			<Route path="operations/cutting" element={<SawCutQueue />} />
			<Route path="operations/cutting/:id" element={<SawCutQueueDetail />} />
			<Route path="operations/kitting" element={<Kitting />} />
			<Route path="operations/delivery" element={<Delivery />} />
			<Route path="operations/qc/machine" element={<QCMachine />} />
			<Route
				path="operations/qc/machine/:id/inspection-results"
				element={<InspectionResultsEntryPage />}
			/>
			<Route path="operations/qc/machine/:id/inspection-results/:sampleId" element={<InspectionResultsEntryPage />} />
			<Route path="operations/qc/keyence" element={<Keyence />} />
			<Route path="operations/qc/product/:id" element={<ProductQualityPage />} />
			<Route path="operations/receiving" element={<ReceivingPage />} />
			<Route path="operations/material-lengths" element={<TabletMaterialLengthsPage />} />
			<Route path="operations/reservations" element={<Reservations />} />
			{/* The hot list and the create flow are one page now. This alias
			    keeps existing links and bookmarks working. */}
			<Route
				path="operations/reservations/create"
				element={<Reservations />}
			/>
			<Route
				path="operations/jaw-configuration"
				element={<JawConfiguration />}
			/>
			<Route path="operations/kit-staging" element={<KitStagingTabletPage />} />
			<Route path="operations/kit-staging/:board" element={<KitStagingTabletPage />} />
		</Routes>
	);
};

export default TabletRoutes;
